import React from 'react';
import AdminHeader from '../../components/adminHeader';
import AdminFooter from '../../components/adminFooter';

const PartnerProfile = () => {
  return (
    <div className="w-full h-full flex flex-col bg-[#00000071]">
      <AdminHeader />
      <div
        style={{
          backgroundImage: "url(/assets/img/landing/landing-bg.png)",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
        className="flex-grow flex flex-col items-center justify-center w-full relative pt-6 px-4"
      >
        <div className="gothic-panel w-full max-w-4xl p-8">
          <h1 className="gothic-heading text-center mb-6">Partner Profile</h1>
          <div className="space-y-4">
            <p className="gothic-text-silver">This is the partner profile page. Here, the Twitch influencer can manage their profile information, payment details, and view their earnings.</p>
            {/* Add more content here for profile management, payment info, earnings, etc. */}
          </div>
        </div>
      </div>
      <AdminFooter />
    </div>
  );
};

export default PartnerProfile;
